
import { Component, Prop, Ref, Vue } from "vue-property-decorator"
import LightDarkSwitch from "@/components/Account/LightDarkSwitch.vue"
import NewInterfaceSwitch from "@/components/Account/NewInterfaceSwitch.vue"
import { Action, Getter, Mutation, State } from "vuex-class"
import { CurrentUser } from "@/types/user"
import { LoginResultTenant } from "@/types"
import api from "@/services/api"
import SetStatusModal from "@/components/SetStatusModal.vue"
import tenantApi from "@/services/api_Tenant"
import { TenantSupport } from "@/types/tenant"
import UserSettingsModal from "@/components/UserSettingsModal.vue"
import SureViewSupportModal from "@/components/SureViewSupportModal.vue"
import NewLightDarkSwitch from "@/components/Account/NewLightDarkSwitch.vue"
import { BaseState } from "@/store"
import TenantInfoDisplay from "@/components/Info/TenantInfoDisplay.vue"
import { TenantFeatures } from "@/types/tenantFeatures"

@Component({
	components: {
		NewLightDarkSwitch,
		SureViewSupportModal,
		"light-dark": LightDarkSwitch,
		"new-interface-switch": NewInterfaceSwitch,
		"set-status-modal": SetStatusModal,
		"user-settings-modal": UserSettingsModal,
		"info-display": TenantInfoDisplay
	}
})
export default class UserMenu extends Vue {
	// TODO remove
	@Ref() setStatusModal!: SetStatusModal
	@Ref() userSettingsModal!: UserSettingsModal

	@Getter isFeatureEnabled!: (feature: TenantFeatures) => boolean
	@Getter("getUseV2") usingV2!: boolean

	@Prop({ type: String, required: true })
	pictureUrl!: string;

	@Prop({ type: Boolean, default: false })
	showNewInterfaceSwitch!: boolean;

	@State((state: BaseState) => state.me) public me!: CurrentUser;
	@Getter("hasSubscription") hasSubscription!: boolean;

	@Action("selectTenant")
	public loginSelectTenant!: (tenant: LoginResultTenant) => Promise<void>

	@Action("logOut")
	public logOut!: () => void;

	@Mutation
	private setManualLogout!: (manualLogout: boolean) => void

	infoShown: boolean = false
	supportAccess: TenantSupport | null = null
	supportAccessOpen: boolean = false
	pictureError: boolean = false

	get infoEnabled (): boolean {
		return this.me && !!this.me.hasTenantInfo && this.isFeatureEnabled(TenantFeatures.TenantInfo)
	}

	private showSetStatus (): void {
		this.setStatusModal.open()
	}

	private showUserSettings (): void {
		this.userSettingsModal.open()
	}

	private async openSupportAccess (): Promise<void> {
		this.supportAccess = await tenantApi.tenantAccess()
		this.supportAccessOpen = true
	}

	private allowAccess (time: string | null): void {
		tenantApi.openSupportAccess({ value: time })
		this.supportAccessOpen = false
	}

	private endAccess (): void {
		tenantApi.openSupportAccess({ value: null })
		this.supportAccessOpen = false
	}

	private get otherTenants (): LoginResultTenant[] {
		if (!this.me || !this.me.loginTenants) {
			return []
		}

		return this.me.loginTenants.filter(t => !t.disabled && t.id !== this.me.tenantId)
	}

	private get userProfilePictureUrl (): string {
		if (this.pictureError) return "images/blank_user.png"
		return this.pictureUrl
	}

	public async logout (): Promise<void> {
		this.setManualLogout(true)

		await api.logout()
		this.logOut()
	}

	public imageUrlError (args: any): void {
		this.pictureError = true
	}
}
